import validate from "/opt/app-root/src/website/node_modules/nuxt/dist/pages/runtime/validate.js";
import localized_45slugs_45global from "/opt/app-root/src/website/app/middleware/localized-slugs.global.ts";
import trailing_45slash_45global from "/opt/app-root/src/website/app/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/opt/app-root/src/website/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  localized_45slugs_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/app-root/src/website/app/middleware/auth.ts")
}